// ProfileTab.js
import { connect } from 'react-redux';

import withRouter from '../component/WithRouter.jsx';
import ProfileTab from '../component/ProfileTab.jsx';
import { replace } from '../action/navigationAction.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getOperationData from '../selector/getOperationData.js';
import getUserData from '../selector/getUserData.js';
import getMeData from '../selector/getMeData.js';
import {
  USER_PROFILE_TABS,
  USER_PROFILE_TABS_DRAFT,
  USER_PROFILE_TABS_GROUP,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { userId }) => {
  const meId = getMeData(state, 'id');
  const username =
    meId != null && meId === userId
      ? getMeData(state, 'username')
      : getUserData(state, userId, 'username');
  return {
    deviceWidth: getOperationData(state, ['device'], 'width'),
    profileTabs: getRemoteConfigData(state, USER_PROFILE_TABS),
    profileTabsDraft: getRemoteConfigData(state, USER_PROFILE_TABS_DRAFT),
    profileTabsGroup: getRemoteConfigData(state, USER_PROFILE_TABS_GROUP),
    username,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    replace: (...args) => dispatch(replace(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProfileTab));
